import React, { Component } from "react";

interface ResizableHandleProps {
  onResize: (width: number) => void;
  minWidth?: number;
  maxWidth?: number;
  currentWidth: number;
}

interface ResizableHandleState {
  isDragging: boolean;
  startX: number;
  startWidth: number;
}

class ResizableHandle extends Component<
  ResizableHandleProps,
  ResizableHandleState
> {
  constructor(props: ResizableHandleProps) {
    super(props);
    this.state = {
      isDragging: false,
      startX: 0,
      startWidth: 0
    };
  }

  componentDidMount() {
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
  }

  handleMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
    this.setState({
      isDragging: true,
      startX: event.clientX,
      startWidth: this.props.currentWidth
    });
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };

  handleMouseMove = (event: MouseEvent) => {
    if (!this.state.isDragging) return;

    const deltaX = event.clientX - this.state.startX;
    const newWidth = this.state.startWidth + deltaX;

    const minWidth = this.props.minWidth || 50;
    const maxWidth = this.props.maxWidth || 700;

    const clampedWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
    this.props.onResize(clampedWidth);
  };

  handleMouseUp = () => {
    if (this.state.isDragging) {
      this.setState({ isDragging: false });
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    }
  };

  render() {
    return (
      <div
        className={`sidebar-resize-handle ${
          this.state.isDragging ? "dragging" : ""
        }`}
        onMouseDown={this.handleMouseDown}
      />
    );
  }
}

export default ResizableHandle;
